import axios from 'axios'
import { globalConfig } from '@/config'

const localState = {
    resetForm: {
        email: '',
        code: '',
        password: '',
        passwordConfirmed: '',
    },
    reseted: true,
    disabled: true,
}

const mutations = {
    setState(state, { key, data }) {
        state[key] = data
    },
    clearForm: (state) => {
        state.resetForm = {
            email: '',
            code: '',
            password: '',
            passwordConfirmed: '',
        }
    },
}

const actions = {
    async resetPassword({ state, commit }) {
        const response = await axios.post(`${globalConfig.originalUrl}/restore/client`, state.resetForm)
        commit('setState', { key: 'reseted', data: false })
        return response.status === 200
    },

    async confirm(_, { email, code }) {
        try {
            return await axios.post(`${globalConfig.originalUrl}/confirmation`, {
                email,
                code,
            })
        } catch (e) {
            return false
        }
    },
}

const getters = {
    resetFormGetters: (state) => state.resetForm,
    isNotResetedGetters: (state) => state.reseted,
    disabledGetters: (state) => state.disabled,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
